var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_29413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.745902 7.82522C0.263559 9.12525 -0.000488281 10.5313 -0.000488281 11.9991C-0.000488281 13.467 0.263559 14.8731 0.745902 16.173L11.9995 17.2165L23.2531 16.173C23.7355 14.8731 23.9995 13.467 23.9995 11.9991C23.9995 10.5313 23.7355 9.12525 23.2531 7.82522L11.9995 6.78174L0.745902 7.82522Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 -0.000976562C6.84061 -0.000976562 2.44205 3.25552 0.746582 7.82513H23.2538C21.5582 3.25552 17.1598 -0.000976562 12.0001 -0.000976562Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 23.9992C17.1598 23.9992 21.5582 20.7427 23.2538 16.1731H0.746582C2.44205 20.7427 6.84061 23.9992 12.0001 23.9992Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_29413"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHu);
export default __webpack_public_path__ + "static/media/HU.1b18119055891a699d3cae98dceacca1.svg";
export { ForwardRef as ReactComponent };